import { PathsV2 } from 'core/services/navigation/pathsV2';
import { ExtractParamsInPath } from 'core/services/navigation/utils/extractParamsInPath';

type GetPathParamsType = {
  [K in keyof typeof PathsV2]: () => ExtractParamsInPath<(typeof PathsV2)[K]>;
};

export const createGetPathParamsFunctions = (
  urlParams: Record<string, string | undefined>
): GetPathParamsType =>
  Object.fromEntries(
    (Object.keys(PathsV2) as Array<keyof typeof PathsV2>).map((key) => [
      key,
      (() => {
        const createGetter = <K extends keyof typeof PathsV2>(routeKey: K) => {
          return () => {
            // Extract parameter names from the path template
            const pathTemplate = PathsV2[routeKey];
            const paramNames =
              pathTemplate.match(/:([^/]+)/g)?.map((match) => match.slice(1)) ||
              [];

            // Build the params object from URL params
            const params: Record<string, string> = {};
            paramNames.forEach((paramName) => {
              params[paramName] = urlParams[paramName] || '';
            });

            return params as ExtractParamsInPath<(typeof PathsV2)[K]>;
          };
        };

        return createGetter(key);
      })()
    ])
  ) as GetPathParamsType;
